var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRailwayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.475,
    height: 38.864,
    viewBox: "0 0 29.475 38.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "railway",
    transform: "translate(-9.11 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11904",
    "data-name": "Path 11904",
    d: "M18.53,18.806a17.634,17.634,0,0,0,8.31,2.412V11.78H18.53Z",
    transform: "translate(-3.609 -3.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11905",
    "data-name": "Path 11905",
    d: "M42.31,11.78H34v9.445a17.685,17.685,0,0,0,8.31-2.412Z",
    transform: "translate(-9.536 -3.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11906",
    "data-name": "Path 11906",
    d: "M34.908,32.513l2.751-2.751V9.071A2.75,2.75,0,0,0,34.908,6.32H15.821A2.75,2.75,0,0,0,13.07,9.071V29.762l2.751,2.751ZM19.8,28.547a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,19.8,28.547Zm11.129,0a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,30.929,28.547ZM15.2,17.066V9.071a.619.619,0,0,1,.617-.617H34.908a.619.619,0,0,1,.617.617v7.995a.608.608,0,0,1-.3.524,18.9,18.9,0,0,1-19.741,0,.625.625,0,0,1-.284-.524Z",
    transform: "translate(-1.517 -1.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11907",
    "data-name": "Path 11907",
    d: "M35.436,3.018A1.522,1.522,0,0,0,33.912,1.5H24.1A1.522,1.522,0,0,0,22.58,3.018v.216H35.442V3.018Z",
    transform: "translate(-5.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11908",
    "data-name": "Path 11908",
    d: "M14.5,50.78,9.11,59.244h4.355l3.794-8.464Z",
    transform: "translate(0 -18.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11909",
    "data-name": "Path 11909",
    d: "M46.438,50.78H43.68l3.794,8.464h4.355Z",
    transform: "translate(-13.244 -18.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11910",
    "data-name": "Path 11910",
    d: "M20.39,58.26l-1.24,2.776H36.238L35,58.26Z",
    transform: "translate(-3.846 -21.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11911",
    "data-name": "Path 11911",
    d: "M22.54,53.963H35.445l-.882-1.993H23.422Z",
    transform: "translate(-5.145 -19.335)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailwayIcon);
export default __webpack_public_path__ + "static/media/railway_icon.5b113bbe3a17a84f87f57440a82c6574.svg";
export { ForwardRef as ReactComponent };